module.exports = __webpack_public_path__ + "img/silver-0.604c23d2.png";